import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

type RenameGroupDialogData = {
  currentName: string;
};

@Component({
  selector: 'app-rename-group-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule],
  templateUrl: './rename-group-dialog.component.html',
  styleUrl: './rename-group-dialog.component.scss',
})
export class RenameGroupDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<RenameGroupDialogComponent, string>);
  private readonly fb = inject(FormBuilder);
  protected readonly data = inject<RenameGroupDialogData>(MAT_DIALOG_DATA);

  protected readonly form = this.fb.nonNullable.group({
    channel_friendly_name: [this.data.currentName || '', [Validators.required, Validators.maxLength(80)]],
  });

  protected close(): void {
    this.dialogRef.close();
  }

  protected save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.controls.channel_friendly_name.value.trim();
    if (!value || value === this.data.currentName.trim()) {
      this.dialogRef.close();
      return;
    }

    this.dialogRef.close(value);
  }

  protected hasControlError(errorName: string): boolean {
    const control = this.form.controls.channel_friendly_name;
    return control.touched && control.hasError(errorName);
  }
}
